/* Bravado Labs cart drawer on Shopify.
   Same drawer markup and classes as Tam's prototype (cart.js), but the cart, totals, subscriptions and
   checkout are Shopify's: /cart/add.js, /cart.js, /cart/change.js, then /checkout.
   Exposes the same window.bravadoCart API the other scripts call (open, add, toast, placeOrder, pending). */
(() => {
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);
  const reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const BL = window.BL || { products: {}, routes: {}, img: "" };
  const R = BL.routes;
  const PD = window.bravadoPD || {};
  const FREE = 35;
  const money = (cents) => `$${(cents / 100).toFixed(2)}`;
  const kOf = (handle) => Object.keys(BL.products).find((k) => BL.products[k] && BL.products[k].handle === handle);

  let cart = { items: [], item_count: 0, items_subtotal_price: 0, total_price: 0, original_total_price: 0 };
  const api = (url, body) => fetch(url, body ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) } : { headers: { Accept: "application/json" } })
    .then((r) => r.ok ? r.json() : r.json().then((j) => Promise.reject(j)));
  const refresh = () => api(R.cart_url + ".js").then((c) => { cart = c; render(); return c; });

  /* ---------- header badge + toast (unchanged from the prototype) ---------- */
  const cartBtn = $(".cart"), cartN = $(".cart-n"), toastEl = $(".toast");
  let tt;
  const toast = (msg) => { toastEl.textContent = msg; toastEl.classList.add("show"); clearTimeout(tt); tt = setTimeout(() => toastEl.classList.remove("show"), 2200); };
  const bump = () => { cartBtn.classList.remove("bump"); void cartBtn.offsetWidth; cartBtn.classList.add("bump"); setTimeout(() => cartBtn.classList.remove("bump"), 400); };
  const fly = (src) => {
    if (!src || reduce) return;
    const a = src.getBoundingClientRect(), b = cartBtn.getBoundingClientRect(); if (!a.width) return;
    const g = src.cloneNode(); g.className = "fly"; g.removeAttribute("style");
    Object.assign(g.style, { left: a.left + "px", top: a.top + "px", width: a.width + "px", height: a.height + "px" });
    document.body.append(g);
    const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    g.animate([{ transform: "translate(0,0) scale(1)", opacity: 1 }, { transform: `translate(${dx * .55}px, ${dy * .55 - 60}px) scale(.45)`, opacity: 1, offset: .6 }, { transform: `translate(${dx}px, ${dy}px) scale(.08)`, opacity: .2 }],
      { duration: 750, easing: "cubic-bezier(.5,0,.3,1)" }).onfinish = () => g.remove();
  };
  const tip = () => {
    const left = FREE * 100 - cart.items_subtotal_price;
    let t = $(".cart-tip"); if (!t) { t = document.createElement("span"); t.className = "cart-tip"; t.setAttribute("role", "status"); cartBtn.parentElement.append(t); }
    t.innerHTML = left <= 0 ? "<b>Free shipping</b> unlocked" : `<b>${money(left)}</b> to free shipping`;
    t.classList.remove("show"); void t.offsetWidth; t.classList.add("show");
    clearTimeout(tip.t); tip.t = setTimeout(() => t.classList.remove("show"), 2800);
  };
  const srcImg = (el) => el && ((el.closest(".rc") && $(".rc-media img", el.closest(".rc"))) || (el.closest(".qv") && $(".qv-img", el.closest(".qv"))) || (el.closest(".z-act") && $(".z-prodimg", el.closest(".z-act"))) || (document.body.classList.contains("pdp-open") && $(".pdp .pdp-img")));

  /* ---------- add: map Tam's product key + size + plan to a Shopify variant (+ selling plan) ---------- */
  const add = ({ k, size, plan, qty, sp }, from) => {
    const p = BL.products[k];
    if (!p || !p.variants) { toast("This product isn't available online right now"); return Promise.resolve(); }
    const label = (size || "").trim();
    const v = p.variants.find((x) => x.title === label) || p.variants.find((x) => x.available) || p.variants[0];
    const item = { id: v.id, quantity: Math.max(1, Math.min(9, qty || 1)) };
    if (plan === "sub" && p.selling_plan_groups && p.selling_plan_groups[0] && p.selling_plan_groups[0].selling_plans[0]) item.selling_plan = (p.selling_plan_groups[0].selling_plans.find((x) => String(x.id) === String(sp)) || p.selling_plan_groups[0].selling_plans[0]).id;
    const img = srcImg(from); fly(img);
    return api(R.cart_add_url + ".js", { items: [item] })
      .then(refresh)
      .then(() => { setTimeout(() => { bump(); tip(); if (navigator.vibrate) navigator.vibrate(12); }, img && !reduce ? 650 : 0); toast(`Added ${(PD[k] && PD[k].name) || p.title}`); })
      .catch((e) => toast((e && (e.description || e.message)) || "Couldn't add that to your cart"));
  };

  /* add buttons: a product page sends its chosen size, plan and quantity; cards add one, one-time */
  document.addEventListener("click", (e) => {
    const b = e.target.closest("[data-add]"); if (!b) return;
    const pdp = b.closest(".pdp");
    if (pdp) {
      const size = $(".pdp-sizes [aria-checked=true]", pdp), sub = $(".plan-sub", pdp);
      add({ k: b.dataset.add, size: size && size.textContent, plan: sub && sub.getAttribute("aria-checked") === "true" ? "sub" : "one", sp: ($(".plan-every select", pdp) || {}).value, qty: +$(".qty output", pdp).textContent }, b)
        .then(() => setTimeout(open, reduce ? 0 : 900));
    } else if (!b.closest(".qv")) add({ k: b.dataset.add, plan: "one", qty: 1 }, b);
  });

  /* ---------- drawer ---------- */
  const cd = document.createElement("div");
  cd.className = "cd"; cd.hidden = true;
  cd.innerHTML = `<aside class="cd-panel" role="dialog" aria-modal="true" aria-labelledby="cd-h"></aside>`;
  document.body.append(cd);
  const panel = $(".cd-panel", cd);

  const render = () => {
    const count = cart.item_count, sub = cart.items_subtotal_price, left = FREE * 100 - sub;
    const saved = cart.items.reduce((t, i) => t + Math.max(0, i.original_line_price - i.final_line_price), 0);
    cartN.textContent = count;
    cartBtn.setAttribute("aria-label", `Cart, ${count} item${count === 1 ? "" : "s"}`);
    panel.innerHTML = `
      <header class="cd-head"><h2 id="cd-h">Your cart <span>${count ? `(${count})` : ""}</span></h2>
        <button type="button" class="cd-x" aria-label="Close cart"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></header>
      ${count ? `
      <div class="cd-ship${left <= 0 ? " free" : ""}"><p>${left <= 0 ? "<b>Free shipping</b> on this order" : `Add <b>${money(left)}</b> more for free shipping`}</p><span class="ship-bar"><i style="--p:${Math.min(1, sub / (FREE * 100)).toFixed(3)}"></i></span></div>
      <ul class="cd-items">${cart.items.map((i) => { const k = kOf(i.handle), d = k && PD[k], isSub = !!i.selling_plan_allocation;
        const img = d && d.img ? BL.img + d.img : (i.image || "");
        const label = (i.variant_title && i.variant_title !== "Default Title") ? i.variant_title : ((d && d.sizes && d.sizes[0] && d.sizes[0][0]) || "");
        const href = k ? `#product-${k}` : i.url; return `
        <li data-key="${esc(i.key)}" data-qty="${i.quantity}">
          <a class="cd-img" href="${href}"><img src="${esc(img)}" alt=""></a>
          <div class="cd-info"><a href="${href}"><b>${esc((d && d.name) || i.product_title)}</b></a><small>${esc(label)}${label ? " · " : ""}${isSub ? "Subscription, " + (String((i.selling_plan_allocation.selling_plan || {}).name || "").replace(/^Deliver /i, "ships ").replace(/,\s*15% off$/i, "") || "ships every month") + ", save 15%" : "One-time purchase"}</small>
            <div class="cd-qty"><button type="button" data-q="-1" aria-label="Decrease quantity">−</button><output>${i.quantity}</output><button type="button" data-q="1" aria-label="Increase quantity">+</button></div></div>
          <div class="cd-price">${i.original_line_price > i.final_line_price ? `<s>${money(i.original_line_price)}</s>` : ""}<b>${money(i.final_line_price)}</b><button type="button" class="cd-rm">Remove</button></div>
        </li>`; }).join("")}</ul>
      <footer class="cd-foot">
        ${saved > 0 ? `<p class="cd-row save"><span>Subscriber savings</span><span>−${money(saved)}</span></p>` : ""}
        <p class="cd-row small"><span>Shipping</span><span>${left <= 0 ? "Free" : "Calculated at checkout"}</span></p>
        <p class="cd-row small"><span>Discount codes</span><span>Added at checkout</span></p>
        <p class="cd-row"><span>Subtotal</span><b>${money(cart.total_price)}</b></p>
        <button type="button" class="pill pill-dark cd-go">Checkout · ${money(cart.total_price)}</button>
        <p class="cd-note">100% money-back guarantee on every order.</p>
      </footer>` : `
      <div class="cd-empty"><p><b>Your cart is empty.</b> Everything ships free over $35, backed by our money-back guarantee.</p><a class="pill pill-dark" href="#needs">Shop all</a></div>`}`;
  };

  let lastFocus = null;
  const open = () => {
    lastFocus = document.activeElement; render();
    cd.hidden = false; document.body.classList.add("cd-on");
    requestAnimationFrame(() => { cd.classList.add("in"); const x = $(".cd-x", cd); x && x.focus(); });
  };
  const close = (refocus = true) => {
    cd.classList.remove("in"); document.body.classList.remove("cd-on");
    setTimeout(() => (cd.hidden = true), reduce ? 0 : 320);
    if (refocus && lastFocus) lastFocus.focus();
  };
  cartBtn.addEventListener("click", (e) => { e.preventDefault(); open(); });
  cd.addEventListener("click", (e) => {
    if (e.target === cd || e.target.closest(".cd-x")) return close();
    if (e.target.closest("a")) return close(false);
    const li = e.target.closest("li[data-key]");
    const change = (q) => api(R.cart_change_url + ".js", { id: li.dataset.key, quantity: q }).then((c) => { cart = c; render(); }).catch(() => toast("Couldn't update your cart"));
    if (li && e.target.closest("[data-q]")) { const q = Math.max(0, Math.min(9, +li.dataset.qty + +e.target.closest("[data-q]").dataset.q)); return change(q); }
    if (li && e.target.closest(".cd-rm")) return change(0).then(() => toast("Removed from cart"));
    if (e.target.closest(".cd-go")) { location.href = R.checkout_url; }
  });
  cd.addEventListener("keydown", (e) => {
    if (e.key === "Escape") return close();
    if (e.key === "Tab") { const f = $$("a, button", cd); if (!f.length) return; if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); } else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); } }
  });

  /* Shopify owns orders and accounts: the prototype's on-device order flow is retired */
  window.bravadoCart = { open, add, toast, placeOrder: () => null, pending: () => false };
  window.bravadoStore = { account: () => ({ signedIn: false, profile: null, address: null, orders: [], subs: [] }), saveAccount: () => {} };
  render(); refresh().catch(() => {});
})();
